<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div>
       <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
    <b-card>
    <h4 class="heading float-left">{{ $t("RecordingDetails") }}</h4>
    <router-link :to="'/company/recording'" class="float-right">
      <b-button variant="primary" class="primary">{{ $t("Back") }}</b-button >
    </router-link>
    <div class="export-table">
      <div class="vx-col">
        <b-row v-if="staffs.inmate_name">
          <b-col >
            <td class="font-semibold">{{ $t("InmateName") }}</td>
          </b-col>
          <b-col >
            <td>
              {{ staffs.inmate_name }}
            </td>
          </b-col>
        </b-row>
        <b-row v-if="staffs.full_user_name">
          <b-col >
            <td class="font-semibold">{{ $t("FullName") }}</td>
          </b-col>
          <b-col >
            <td>
              {{ staffs.full_user_name }}
            </td>
          </b-col>
        </b-row>
        <b-row v-if="staffs.appointment_date">
          <b-col >
            <td class="font-semibold">{{ $t("Date") }}</td>
          </b-col>
          <b-col >
            <td>
              {{ staffs.appointment_date }}
            </td>
          </b-col>
        </b-row>
        <b-row v-if="staffs.appointment_start_time">
          <b-col >
            <td class="font-semibold">{{ $t("Time") }}</td>
          </b-col>
          <b-col >
            <td>
              {{ staffs.appointment_start_time }}
            </td>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-card>
    </b-overlay>
</div>
  
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      staffs: [],
        show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
    };
  },
  created() {
    this.getstaffs(this.$route.params.id);
  },

  methods: {
    /**
     *  getstaffs method get all companies from company list
     **/

    getstaffs(id) {
      this.success = "";
      this.error = "";
      this.show = true;
      this.$store
        .dispatch("ShowRecording", id)
        .then((res) => {
          this.show=false;
          this.staffs = res.data.data;

          let time = moment(
            this.staffs.appointment_start_time,
            "h:mm a"
          ).format("LT");
          this.staffs.appointment_start_time = time;
        })
        .catch((error) => {
          this.$log.error(
            "File : Show.vue | Function : getstaffs() | Error :",
            error
          );
        this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
  },
};
</script>

<style lang="stylus" scope>
.heading {
  margin-bottom: 20px;
}

.add {
  position: absolute;
  margin-top: 10px;
}

.action {
  margin-left: 20px;
  display: inline;
}

.space {
  margin-top: 20px;
}

.vs-row {
  padding: 10px;
}

.confLink {
  word-break: break-word !important;
}

#cancel {
}
</style>